import { render, staticRenderFns } from "./RelListNotificacoes.vue?vue&type=template&id=e55c8c3e"
import script from "./RelListNotificacoes.vue?vue&type=script&lang=js"
export * from "./RelListNotificacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports